import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './BaseChip.module.scss';

const SCHEMAS = {
  filter: 'filter',
  choice: 'choice',
  tag: 'tag',
  blue: 'blue'
};

const BaseChip = ({
  renderLeadingIcon,
  renderTrailingIcon,
  label,
  colorSchema,
  onClick,
  isSelected,
  shadowed,
  withBorder,
  isActivated,
  isDarkMode,
  isOverlay,
  className,
  dataTest,
  isSpaced
}) => {
  const selectableProps = onClick
    ? {
        tabIndex: 0,
        role: 'button',
        onClick
      }
    : {
        tabIndex: -1
      };

  const chipClassNames = classNames(
    styles.chip,
    styles[`chip--schema-${colorSchema}`],
    {
      [styles[`chip--schema-${colorSchema}--with-border`]]: withBorder,
      [styles[`chip--shadowed`]]: shadowed,
      [styles[`chip--schema-${colorSchema}--dark-mode`]]: isDarkMode,
      [styles[`chip--schema-${colorSchema}--selected`]]: isSelected,
      [styles[`chip--schema-${colorSchema}--activated`]]:
        isActivated && !isDarkMode,
      [styles[`chip--schema-${colorSchema}--activated-dark`]]:
        isActivated && isDarkMode,
      [styles[`chip--schema-${colorSchema}--overlay`]]: isOverlay
    },
    className
  );
  const labelClassNames = classNames(styles.chip__label, {
    [styles['chip__label--spaced']]: isSpaced
  });

  return (
    <div className={chipClassNames} {...selectableProps} data-test={dataTest}>
      {renderLeadingIcon ? renderLeadingIcon() : null}
      <div className={labelClassNames}>{label}</div>
      {renderTrailingIcon ? renderTrailingIcon() : null}
    </div>
  );
};

BaseChip.SCHEMAS = SCHEMAS;

BaseChip.propTypes = {
  onClick: PropTypes.func,
  renderLeadingIcon: PropTypes.func,
  renderTrailingIcon: PropTypes.func,
  isSelected: PropTypes.bool,
  isActivated: PropTypes.bool,
  shadowed: PropTypes.bool,
  withBorder: PropTypes.bool,
  label: PropTypes.string.isRequired,
  colorSchema: PropTypes.oneOf(Object.values(SCHEMAS)).isRequired,
  className: PropTypes.string,
  isDarkMode: PropTypes.bool,
  isOverlay: PropTypes.bool,
  dataTest: PropTypes.string,
  isSpaced: PropTypes.bool
};

BaseChip.defaultProps = {
  isSelected: false,
  isActivated: false,
  shadowed: false,
  withBorder: false,
  onClick: () => {},
  renderLeadingIcon: null,
  renderTrailingIcon: null,
  className: null,
  isDarkMode: false,
  isOverlay: false,
  dataTest: null,
  isSpaced: false
};

export default BaseChip;
